module.exports = __webpack_public_path__ + "static/media/FiraSans-ExtraLightItalic.c606dc72.ttf";